import app from '@core/configApp.ts'
import { i18n } from '@core/plugins/plugin-i18n.ts'
import { router } from '@core/plugins/plugin-router.ts'
import OpenLayersMap from 'vue3-openlayers'
import './assets/base.css'

import './style.css'
import '@core/plugins/plugin-head.ts'
import '@core/plugins/plugin-fontawesome.ts'
import '@core/plugins/plugin-primevue.ts'

if (import.meta.env.DEV) {
  if (window.location.hostname === 'localhost') {
    window.location.hostname = 'leisureking.localhost'
  }
}
app
  .use(OpenLayersMap)
  .use(i18n)
  .use(router)
async function initializeApp() {
  if (import.meta.env.VITE_MOCKED === 'true') {
    const { setupWorker } = await import('msw/browser')
    const { mockHandlers } = await import('./mocks/mockHandlers')

    await setupWorker(...mockHandlers).start({ onUnhandledRequest: 'bypass' })
  }
  app.mount('#app')
}

initializeApp().then()
